export default "__VITE_ASSET__eacfaa68__"